import React from "react";

import ChoiceCard from "../components/ChoiceCard.jsx";
import LoadingOrEmpty from "../components/LoadingOrEmpty.jsx";
import { getCardImage } from "../characterCreatorUtils.js";

export default function StartingPointStep({ state, startingPoints, onSelectStartingPoint, onPatch }) {
  return (
    <>
      <div className="card-grid sp-grid" id="spCards">
        <LoadingOrEmpty items={startingPoints} loadingText="Carregando…" emptyText="Nenhum starting point disponível.">
          {startingPoints?.map((startingPoint) => {
            const isLegendary = startingPoint.level === 5;
            const className = `sp-card${isLegendary && startingPoint.available !== false ? " sp-legendary" : ""}`;

            return (
              <ChoiceCard
                key={startingPoint.level}
                className={className}
                selected={state.startingPoint === startingPoint.level}
                locked={startingPoint.available === false}
                imageUrl={getCardImage("nivel", startingPoint)}
                imageLabel={`Nível ${startingPoint.level} ${startingPoint.name}`}
                onClick={() => onSelectStartingPoint(startingPoint)}
              >
                {startingPoint.available === false ? (
                  <>
                    <div className="lock-icon">🔒</div>
                    <div className="sp-level">{startingPoint.level}</div>
                    <div className="sp-name">{startingPoint.name}</div>
                    <div className="lock-msg">{startingPoint.lockedMessage}</div>
                  </>
                ) : (
                  <>
                    <div className="sp-level">{startingPoint.level}</div>
                    <div className="sp-name">{startingPoint.name}</div>
                    <div className="sp-narrative">{startingPoint.narrative}</div>
                    <ul className="sp-features">
                      {startingPoint.features.map((feature) => (
                        <li key={feature}>{feature}</li>
                      ))}
                    </ul>
                  </>
                )}
              </ChoiceCard>
            );
          })}
        </LoadingOrEmpty>
      </div>
      <div className="field-group" style={{ marginTop: "1rem" }}>
        <label htmlFor="bioField">
          Contexto narrativo do personagem <small>(opcional)</small>
        </label>
        <textarea
          id="bioField"
          rows="3"
          placeholder="Em 2-4 frases, o que seu personagem estava fazendo antes de entrar na campanha…"
          value={state.biography}
          onChange={(event) => onPatch({ biography: event.target.value })}
        />
      </div>
    </>
  );
}
